/**
 * For a dialog that is a whole form rather than a question: on a phone it takes the screen.
 *
 * Floating with a margin all round and capped at 90% of the height, the lead form left a phone a
 * window of three fields between its header and its two stacked buttons — and the phone is where
 * leads get written, at the stand. From `sm` up nothing changes.
 */
export const PHONE_FULL_SCREEN_DIALOG =
  'max-sm:h-dvh max-sm:max-h-none max-sm:max-w-none max-sm:ring-0'
